<template>
    <div class="location-details" v-if="location">
      <div class="header">
        <h2>{{ isEditMode ? "Edit Location" : location.name }}</h2>

        <div class="top-buttons">
        <button @click="toggleEditMode" class="icon-btn">
          <i class="bi bi-pencil"></i>
        </button>
        <button class="remove-btn" @click="deleteLocation">
          <i class="bi bi-trash"></i>
        </button>
        </div>
      </div>
  
      <!-- Display mode -->
      <div v-if="!isEditMode">
        <div class="detail"><strong>Description:</strong> {{ location.description }}</div>
      </div>
  
      <!-- Edit mode -->
      <div v-else>
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" id="name" v-model="editableLocation.name">
        </div>
        <div class="form-group">
          <label for="description">Description</label>
          <textarea id="description" v-model="editableLocation.description"></textarea>
        </div>
        <div class="buttons-container">
          <button @click="saveChanges">Save</button>
          <button @click="cancelEditMode">Cancel</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { API_ENDPOINTS } from '@/services/config';
  import apiService from '@/services/apiService';
  import { confirmDelete } from "@/utils/confirmDelete";
  import { useToast } from 'vue-toastification';
  import { mapState } from 'vuex';

  
  export default {
    props: {
      location: {
        type: Object,
        required: true,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState(['loggedInUser']),
    },
    data() {
      return {
        isEditMode: false,
        editableLocation: {},
      };
    },
    setup() {
      const toast = useToast();
      return { toast };
    },
    methods: {
      toggleEditMode() {
        this.isEditMode = true;
        this.editableLocation = JSON.parse(JSON.stringify(this.location));
      },
      async saveChanges() {
        this.$emit('updateLocation', this.editableLocation);
        this.isEditMode = false;
      },
      cancelEditMode() {
        this.isEditMode = false;
      },
      async deleteLocation() {
        const locationId = this.location.id;
        try {
          const isConfirmed = await confirmDelete("Are you sure you want to delete this Location?");
          if (!isConfirmed) return; 

          await apiService.deleteResource(API_ENDPOINTS.location(locationId), this.loggedInUser.id, this.loggedInUser.entra_id);
          this.$router.push({ name: "LocationList" });
          this.toast.success("Location deleted successfully!");
        } catch (error) {
          console.error('Error deleting location:', error);
          this.toast.error("Failed to delete location!");
        }
      }
    },
  };
  </script>
  
  <style scoped lang="scss">
  @import "@/assets/variables.scss";
  
  .location-details {
    max-width: 800px;
    margin: 0 auto;
    padding: 15px 20px;
    border-radius: 8px;
    background-color: $secondary-color;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  
    .buttons-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      align-items: flex-end;
  
      .left-buttons, .right-buttons {
        display: flex;
        gap: 10px;
      }
    }
    .top-buttons {
      display: flex;
      gap: 10px;
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
  
      h2 {
        color: $primary-color;
        margin-bottom: 20px;
      }
    }
  
    .detail {
      margin-bottom: 3px;
      font-size: 16px;
      strong {
        color: $primary-color;
      }
    }
  }
  </style>
  